import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhLoadingComponent } from './components/fh-loading/fh-loading.component';
import { FhImageModule } from '@fh-client-interaction-frontends/fh-image';
import { TranslateModule } from '@ngx-translate/core';
import { FhAlertModule } from '@fh-client-interaction-frontends/fh-alert';
import { FhCardModule } from '@fh-client-interaction-frontends/fh-card';
import { FhSvgImagesModule } from '@fh-client-interaction-frontends/fh-svg-images';
import { FhButtonModule } from '@fh-client-interaction-frontends/fh-button';
import { FhTextModule } from '@fh-client-interaction-frontends/fh-text';

@NgModule({
  imports: [CommonModule, FhImageModule, TranslateModule, FhAlertModule, FhCardModule, FhSvgImagesModule, FhButtonModule, FhTextModule],
  declarations: [FhLoadingComponent],
  exports: [FhLoadingComponent]
})
export class FhLoadingModule {}
